







import { Component } from "vue-property-decorator";
import AbstractScene from "@/components/AbstractScene.vue";
import ResultSceneBackground from "@/components/ResultSceneBackground.vue";
import StarBackground from "@/components/StarBackground.vue";

@Component({
  components: {
    ResultSceneBackground,
    StarBackground,
  },
})
export default class PikaaScene extends AbstractScene {}
